import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Interviewee } from '@smooved/core';
import { intervieweeOptions, SelectInput } from '@smooved/ui';
import { InterviewInitiatedByType } from '../../enums/interview-initiated-by-type.enum';
import { SurveysSandbox } from '../../sandboxes/surveys.sandbox';

@Component({
    selector: 'app-start-interview-container',
    template: `
        <smvd-ui-wizard-step-card [header]="'SHARED.SURVEYS.SELECT_INTERVIEWEE' | translate" [hasNext]="true" (next)="onSubmit()">
            <form [formGroup]="form" class="u-flex-column u-flex-align-items-start u-margin-top-double u-w100p">
                <app-select-input
                    [custom]="false"
                    [hasMargin]="false"
                    [hasMarginDouble]="true"
                    [formControlName]="'assessedTo'"
                    [options]="intervieweeOptions"
                ></app-select-input>
            </form>
        </smvd-ui-wizard-step-card>
    `,
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class StartInterviewContainer {
    public form: UntypedFormGroup = this.formBuilder.group({
        assessedTo: [null, [Validators.required]],
    });

    public readonly intervieweeOptions: SelectInput<Interviewee>[] = intervieweeOptions;

    constructor(
        private formBuilder: UntypedFormBuilder,
        private router: Router,
        private route: ActivatedRoute,
        private surveySandbox: SurveysSandbox
    ) {}

    public onSubmit(): void {
        this.form.markAllAsTouched();
        if (!this.form.valid) return;
        const assessedTo = this.form.get('assessedTo').value;
        this.surveySandbox.getInterview(assessedTo, InterviewInitiatedByType.Admin, (interview) => {
            this.router.navigate(['..', assessedTo, interview.pages[0]?.id], { relativeTo: this.route });
        });
    }
}
